import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'prodScheduleWorkstationTitle',
  standalone: true,
})
export class ProdScheduleWorkstationTitlePipe implements PipeTransform {
  transform(
    workstationId: number,
    workstationTitles: { [workstationId: number]: string }
  ): string {
    return workstationTitles[workstationId] || `Workstation ${workstationId}`;
  }
}
